import SponsorPackageHead from './SponsorPackageHead'
import SponsorPackageBody from './SponsorPackageBody'
import SponsorPackageFooter from './SponsorPackageFooter'
import { useParams } from 'react-router'

export default function SponsorPackage({ pkg, duration, setDuration }) {
  const { lng } = useParams()
  return (
    <div
      data-aos={`fade-up`}
      className="col-span-12 flex flex-col lg:col-span-6"
    >
      <SponsorPackageHead
        icon={`${process.env.REACT_APP_API_BASE_URL}/storage/${pkg.logo}`}
        name={pkg[`name_${lng}`]}
      />
      <SponsorPackageBody items={pkg.sponsor_package_items} />
      <SponsorPackageFooter
        sponsor_package_id={pkg.id}
        duration={duration}
        setDuration={setDuration}
        yearPrice={pkg.year_price}
        hanlfYearPrice={pkg.half_year_price}
        sold={pkg.sold}
      />
    </div>
  )
}
